type PanelPreferenceValue = 'open' | 'closed';
export type PanelModeValue = 'sidepanel' | 'fullscreen';

// Whether Bizy was open the last time the member opened or closed it, used once per
// app load to decide whether to auto-open. The `-general` suffix is a leftover from a
// second per-page-type key ('meeting') that no longer exists; the storage name is kept
// as-is so nobody's saved choice gets reset by the rename. Any orphaned
// `bizy-panel-pref-meeting` value is simply never read again.
const STORAGE_KEY = 'bizy-panel-pref-general';
const MODE_KEY = 'bizy-panel-mode';
const DECK_NAVIGATION_HINT_KEY = 'bizy-deck-navigation-hint-shown';

export function getBizyPanelPreference(): PanelPreferenceValue {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'closed' ? 'closed' : 'open';
	} catch {
		return 'open';
	}
}

export function setBizyPanelPreference(value: PanelPreferenceValue): void {
	try {
		localStorage.setItem(STORAGE_KEY, value);
	} catch {
		// localStorage unavailable
	}
}

export function getBizyPanelMode(): PanelModeValue {
	try {
		const value = localStorage.getItem(MODE_KEY);
		return value === 'fullscreen' ? 'fullscreen' : 'sidepanel';
	} catch {
		return 'sidepanel';
	}
}

export function setBizyPanelMode(value: PanelModeValue): void {
	try {
		localStorage.setItem(MODE_KEY, value);
	} catch {
		// localStorage unavailable
	}
}

export function hasShownBizyDeckNavigationHint(): boolean {
	try {
		return localStorage.getItem(DECK_NAVIGATION_HINT_KEY) === '1';
	} catch {
		return false;
	}
}

export function markBizyDeckNavigationHintShown(): void {
	try {
		localStorage.setItem(DECK_NAVIGATION_HINT_KEY, '1');
	} catch {
		// localStorage unavailable
	}
}

/** Fullscreen default opens closed each session; only side-panel default auto-opens from saved prefs. */
export function shouldAutoOpenBizyPanel(): boolean {
	return getBizyPanelMode() !== 'fullscreen';
}

const TRIAL_AUTO_OPEN_PREFIX = 'bizy_trial_auto_opened:';

export function hasTriggeredTrialAutoOpen(userId: string): boolean {
	try {
		return sessionStorage.getItem(`${TRIAL_AUTO_OPEN_PREFIX}${userId}`) === '1';
	} catch {
		return false;
	}
}

export function markTrialAutoOpenTriggered(userId: string): void {
	try {
		sessionStorage.setItem(`${TRIAL_AUTO_OPEN_PREFIX}${userId}`, '1');
	} catch {
		// sessionStorage unavailable
	}
}
